import styles from './PrizeGroupingHeader.module.css';
import { ReactElement, useState } from 'react';
import Link from 'next/link';
import { ASSET_PREFIX } from 'utils/constants';
import {
  getMatchText,
  IPrizeTableEntry,
} from 'components/how-it-works/prizeTableData';
import { OptionalLink } from 'components/common/OptionalLink';

interface Props {
  /** The title of the group. This is a ReactElement to support strong and em elements in titles */
  categoryTitle: ReactElement | string;
  categorySubtitle: string;
  image: ReactElement;
  groupingPageHref: string;
  renderAsLink: boolean;
  criteria?: IPrizeTableEntry | undefined;
}
const PrizeGroupingHeader = (props: Props) => {
  const [categoryInfoVisible, setCategoryInfoVisible] = useState(false);

  return (
    <div className={styles.header}>
      <div className={styles.categoryImage}>
        <OptionalLink
          href={props.renderAsLink ? props.groupingPageHref : undefined}
          className={styles.categoryLink}
        >
          {props.image}
        </OptionalLink>
      </div>
      <div>
        <OptionalLink
          href={props.renderAsLink ? props.groupingPageHref : undefined}
          className={styles.categoryLink}
        >
          <h2 className="aboutUsTypographyHeaderLarge">
            {props.categoryTitle}
          </h2>
          <p className={styles.subtitle}>{props.categorySubtitle}</p>
        </OptionalLink>
      </div>
      {props.criteria && (
        <div className={styles.categoryInfoContainerOuter}>
          <div
            className={`${styles.categoryInfoContainer} ${categoryInfoVisible ? styles.categoryInfoVisible : ''}`}
          >
            <button
              className={styles.categoryInfoButton}
              onClick={() => setCategoryInfoVisible((x) => !x)}
            >
              <img
                width="16"
                height="16"
                src={`${ASSET_PREFIX}/images/info-circle.svg`}
              />
            </button>
            <div className={styles.categoryInfoContent}>
              <div className={styles.categoryInfo}>
                <img
                  width="20"
                  height="20"
                  className={styles.ballIcon}
                  src={`${ASSET_PREFIX}/images/how-it-works/balls.png`}
                  alt=""
                />
                <p> {getMatchText(props.criteria)}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PrizeGroupingHeader;
